import { api } from "./customers";

// Interface for CarePackage
export interface CarePackage {
  id: number;
  packageName: string;
  discount: string;
  price: string;
  validityPeriod: string;
  services: Service[];
  activeStatus: any;
  createdAt: string;
  updatedAt: string;
}

interface UpdateCarePackageStatusArgs {
  id: any; // or number
  activeStatus: string;
}


export interface ProcedureTitle {
  id: number;
  procedureTitle: string;
}

// Interface for Service included in CarePackage
export interface Service {
  id: string;
  procedureName: string;
}

// API configuration for Care Packages
export const CarePackagesApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Get Procedure Titles
    getProcedureTitles: build.query<any, void>({
      query: () => `procedure-tittle-only`,
    }),

    // Get all Care Packages
    getCarePackages: build.query<CarePackage[], { pageNo: number; name: any }>(
      {
        query: ({ pageNo, name }) =>
          `care_packages?page=${pageNo}&search=${name}`,
      }
    ),

    // Create a Care Package
    createCarePackage: build.mutation<CarePackage, Partial<CarePackage>>({
      query: (body) => ({
        url: `care_packages`,
        method: "POST",
        body,
      }),
    }),

    // Update a Care Package
    updateCarePackage: build.mutation<
      CarePackage,
      Pick<CarePackage, "id"> & Partial<CarePackage>
    >({
      query: ({ id, ...patch }) => ({
        url: `care_packages/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),

    // Delete a Care Package
    deleteCarePackage: build.mutation<{ success: boolean; id: number }, number>({
      query: (id) => ({
        url: `care_packages/${id}`,
        method: "DELETE",
      }),
    }),

    // Get Assignment History
    getAssignmentHistory: build.query<any, { pageNo: number, name: any }>(
      {
        query: ({ pageNo,name }) =>
          `assignment_history?page=${pageNo}&search=${name}`,
      }
    ),

     updateCarePackageStatuse: build.mutation<CarePackage, UpdateCarePackageStatusArgs>({
      query: ({ id, activeStatus }) => ({
        url: `care_packages/${id}/status`,
        method: "PUT",
        body: { activeStatus },
      }),
    }),

    createAssignmentHistory: build.mutation<CarePackage, Partial<CarePackage>>({
      query: (body) => ({
        url: `assignment_history`,
        method: "POST",
        body,
      }),
    }),


    putUpdateAssignmentHistory: build.mutation<CarePackage, Partial<CarePackage>>({
      query: (body) => ({
        url: `assignment_history`,
        method: "POST",
        body,
      }),
    }),

    // Update the status of a Care Package
   

    getCarePackageLists: build.query<any, any>({
      query: () => `care_packages_list`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: any },
        meta,
        arg
      ) => response.data,
    }),

    getCarePackageListsById: build.query<any, any>({
      query: (id) => `care_packages_list?carePackageId=${id}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: any },
        meta,
        arg
      ) => response.data,
    }),
  }),
});

// Export hooks for queries and mutations
export const {
  useGetCarePackagesQuery,
  useCreateCarePackageMutation,
  useUpdateCarePackageMutation,
  useDeleteCarePackageMutation,
  useGetAssignmentHistoryQuery,
  useGetProcedureTitlesQuery,
  useUpdateCarePackageStatuseMutation,
  useGetCarePackageListsQuery,
  useGetCarePackageListsByIdQuery,
  useCreateAssignmentHistoryMutation,
  usePutUpdateAssignmentHistoryMutation
} = CarePackagesApi;
